import React, { createContext, useState, useContext, ReactNode } from 'react';

// Define the type for the context
interface Answer {
  questionId?: string; 
  answer: string;
}
interface QuizContextType {
  answers: Record<string, Answer>; // Stores answers and their questionIds
  setAnswer: (questionKey: string,answer: string, questionId?: string) => void; // Updated function
}
// Create the context
const QuizContext = createContext<QuizContextType | undefined>(undefined);

// Provider component to wrap around the app or necessary part of the app
export const QuizProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [answers, setAnswers] = useState<Record<string, Answer>>({});

  const setAnswer = (questionKey: string, answer: string, questionId?: string) => {
    setAnswers((prev) => ({
      ...prev,
      [questionKey]: { questionId, answer },
    }));
  };

  return (
    <QuizContext.Provider value={{ answers, setAnswer }}>
      {children}
    </QuizContext.Provider>
  );
};

// Custom hook to use the QuizContext
export const useQuizContext = () => {
  const context = useContext(QuizContext);
  if (!context) {
    throw new Error('useQuizContext must be used within a QuizProvider');
  }
  return context;
};
